<template>
  <Header />
  <div class="heading">
    <h1>Assign Instructors to Session ID: {{ $route.params.project_id }}</h1>
  </div>

  <div class="search-container">
    <input type="text" v-model="searchQuery" placeholder="Search by Name" />
  </div>

  <div class="pagination-button-container">
    <div class="pagination-container">
      <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage" @page-change="onPageChange" />
    </div>
    <div class="pagination-info">
      Showing {{ startIndex + 1 }}-{{ endIndex }} of {{ filteredInstructorsLength }} Instructors
    </div>
  </div>

  <div class="container-fluid">
    <table class="data-table-trainee">
      <thead>
        <tr>
          <th @click="sortBy('user_id')">
            ID
            <span v-if="sortField === 'user_id'" v-html="getFieldArrow()"></span>
          </th>
          <th @click="sortBy('first_name')">
            First Name
            <span v-if="sortField === 'first_name'" v-html="getFieldArrow('first_name')"></span>
          </th>
          <th>Last Name</th>
          <th>Email</th>
          <th>Assign Instructor</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in filteredInstructors" :key="item.user_id">
          <td>{{ item.user_id }}</td>
          <td>{{ item.first_name }}</td>
          <td>{{ item.last_name }}</td>
          <td>{{ item.email }} </td>
          <td>
            <input type="checkbox" v-model="selectedInstructors" :value="item.user_id">
          </td>
        </tr>
        <tr v-if="filteredInstructors.length === 0">
          <td colspan="100" style="text-align: center;">No Matching Instructors</td>
        </tr>
      </tbody>
    </table>

  </div>
    <button class="back-button" @click="goBack">Back</button>
    <button class="btn btn-primary rounded" @click="assignSelectedInstructors">Assign Instructors</button>
    <button class="btn btn-primary rounded" @click="goUnAssign">Un-Assign Instructors</button>
</template>
    
<script>
import Header from '../Header.vue';
import axios from 'axios';
import Pagination from '../TablePagination.vue';

export default {
  name: 'AssignInstructors',
  data() {
    return {
      instructors: [],
      selectedInstructors: [],
      sortField: 'user_id',
      sortDirection: 'asc',
      searchQuery: '',
      projectSearchQuery: '',
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      newProject: {
        name: '',
        course_id: '',
        course_name: '',
        user_id: '',
      },
      filteredInstructorsLength: 0,
    };
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1; // Reset currentPage to 1 when searchQuery changes
      }
    },
  },
  components: {
    Pagination,
    Header
  },
  async mounted() {
  try {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
    const project_id = this.$route.params.project_id;

    // Fetch the instructors assigned to the project
    const response = await axios.get(`/api/projects/${project_id}/users`, { headers });
    const assignedInstructors = response.data;

    // Now, you have the assigned instructors in the 'assignedInstructors' variable.
    console.log(assignedInstructors);

    // Fetch all instructors (including those assigned to the project)
    const result = await axios.get('/api/users', { headers });

    if (result.status === 200) {
      // Filter the response data to include only users with the role 'instructor'
      this.instructors = result.data.filter(user => user.role === 'instructor');

        // Check the checkboxes of instructors already assigned to the project
        this.instructors.forEach(instructor => {
        if (assignedInstructors.some(assignedInstructor => assignedInstructor.user_id === instructor.user_id)) {
          this.selectedInstructors.push(instructor.user_id);
        }
      });
    }

    this.totalPages = Math.ceil(this.instructors.length / this.perPage);

  } catch (error) {
    console.error('An error occurred while fetching data:', error);
  }
},
  methods: {
    editInstructor(user_id) {
      window.location.href = `/instructors/${user_id}`;
    },
    sortBy(field) {
      if (this.sortField === field) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortDirection = 'asc';
      }

      this.instructors.sort((a, b) => {
        const valueA = a[field];
        const valueB = b[field];

        if (typeof valueA === 'number' && typeof valueB === 'number') {
          return (this.sortDirection === 'asc' ? 1 : -1) * (valueA - valueB);
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
          return (this.sortDirection === 'asc' ? 1 : -1) * valueA.localeCompare(valueB);
        } else {
          return 0;
        }
      });
    },
    getFieldArrow(field = 'user_id') {
      if (this.sortField === field) {
        return this.sortDirection === 'asc' ? '▲' : '▼';
      } else {
        return '';
      }
    },
    onPageChange(page) {
      this.currentPage = page;
    },
    assignSelectedInstructors() {
      if (this.selectedInstructors.length === 0) {
        return;
      }

      const project_id = this.$route.params.project_id;
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

  // Fetch the current instructors assigned to the course
  axios.get(`/api/projects/${project_id}/users`, { headers })
    .then(response => {
      const existingInstructors = response.data.map(instructor => instructor.user_id);

      // Filter out instructors already assigned to the project
      const newInstructors = this.selectedInstructors.filter(instructorId => !existingInstructors.includes(instructorId));
      console.log(newInstructors);
      if (newInstructors.length === 0) {
        window.alert('All selected instructors are already in the Session.');
        this.selectedInstructors = [];
        return;
      }

      // Step 2: Assign new instructors to the project
      const projectData = {
        user_ids: newInstructors,
        role: 'instructor'
      };
      // Return a combined promise to maintain the chain
      return axios.post(`/api/projects/${project_id}/add-users`, projectData, { headers })
        .then(response => {
          console.log('Instructors added to the Session:', response);
          // Step 3: Fetch the logbooks for the project
          return axios.get(`/api/projects/${project_id}/logbooks`, { headers });
        })
        .then(logbookResponse => {
          const logbooks = logbookResponse.data;
          // Collect logbook IDs
          const logbookIds = logbooks.map(logbook => logbook.logbook_id);
          // Step 4: Assign new instructors to all logbooks in a single request
          const logbookData = {
            user_ids: newInstructors,
            logbook_ids: logbookIds,
            project_id: project_id,
          };
          return axios.post(`/api/logbooks/add-users-to-logbook`, logbookData, { headers });
        });
    })
    .then(logbookAssignResponse => {
      if (logbookAssignResponse) {
        console.log('Instructors added to logbooks:', logbookAssignResponse);
        window.alert('Instructors added successfully to the Session and logbooks');
      }
      this.selectedInstructors = [];
      this.$router.push({ name: 'ViewProjects' });
    })
    .catch(error => {
      console.error('Error assigning instructors or fetching logbooks:', error);
      if (error.response.data.message === "The logbook ids field is required.") {
        window.alert('Instructors added successfully to the Session.');
        // Logbooks are not found, but instructors are still assigned to the project.
        this.selectedInstructors = [];
        this.$router.push({ name: 'ViewProjects' });
        return;
      }
      // Handle errors, e.g., display an error message.
    });
},

goBack() {
      this.$router.push({ name: 'ViewProjects'});
    },
    goUnAssign() {
      this.$router.push({ name: 'ViewInstructors'});
    },
    calculateTotalPages() {
      this.computeFilteredInstructors();
      this.totalPages = Math.ceil(this.filteredInstructorsLength / this.perPage);
    },
    computeFilteredInstructors() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;

      const filteredInstructors = this.instructors.filter((instructor) => {
        const fullName = (instructor.first_name + instructor.last_name || "").toLowerCase(); // Fallback to empty string if null or undefined
        const instructorMatch = fullName.includes(this.searchQuery.toLowerCase()) || this.searchQuery === '';

        return instructorMatch
      });

      console.log(filteredInstructors);
      this.filteredInstructorsLength = filteredInstructors.length;
      console.log(this.filteredInstructorsLength);
      return filteredInstructors.slice(startIndex, endIndex);
  },
},
  computed: {
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      const end = this.startIndex + this.perPage;
      return end < this.filteredInstructorsLength ? end : this.filteredInstructorsLength;
    },
    filteredInstructors() {
      return this.computeFilteredInstructors();
    },
  },
};
</script>
    
    
<style scoped>
span:hover {
  cursor: pointer;
  color: blue;
}

.pagination-container {
    margin-top: 55px;
    display: flex;
    margin-left: 3%;
}

.container-fluid {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

.search-container input[type="text"] {
  margin-left: 40px;
  padding: 10px;
  font-size: 16px;
  width: 30%;
}

button.btn {
  padding: 10px 10px;
  font-size: 16px;
  width: 180px;
  height: 40px;
  margin-top: 0%;
  margin-bottom: 15px;
  border: 1px solid rgb(0, 96, 134);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  float: right;
  margin-right: 30px;
}

button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

.heading h1 {
  padding-top: 30px;
  padding-bottom: 10px;
  text-align: left;
  padding-left: 3%;

}

.back-button {
  /* Adjust the right position as needed */
  width: 100px;
  border-radius: 5px;
  background-color: #c1e0bf;
  float: left;
  margin-left: 30px;
  border: 2px solid black;
  padding: 3px;
}

button:hover {
  background-color: #7c927a;
  transition: transform 0.2s, box-shadow 0.2s;
}
.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.pagination-info {
  font-size: 14px;
  color: #666;
  /* Adjust the color as needed */
  position: absolute;
  top: 300px;
  left: 50%;
  /* Center horizontally */
  transform: translateX(-50%);
  /* Center horizontally */
}
</style>